import { Component } from '@angular/core';
import { MyDocCollabsConstants } from './constants/my-doc-collabs-constant';
import { DocumentSearchResult } from '../document/models/documentSearchResult';
import { DocumentLibraryConstants } from '../document/document-library-constants';
import { MyDocCollabsService } from './services/my-doc-collabs.service';
import { LabelConstants } from '../shared/constants/label-constants';

@Component({
  selector: 'app-my-doc-collabs',
  templateUrl: './my-doc-collabs.component.html',
  styleUrls: ['./my-doc-collabs.component.scss']
})
export class MyDocCollabsComponent {
  topBarTitle:string = MyDocCollabsConstants.MyDocCollabs_TopBarTitle;
  showAllLabel:string=MyDocCollabsConstants.MyDocCollabs_ShowAllLabel;
  isIncludeAll = MyDocCollabsConstants.MyDocCollabs_IsIncludeAll;
  showInformationIconCheckbox = MyDocCollabsConstants.MyDocCollabs_ShowInformationIconCheckbox;
  inactiveTooltip:string = MyDocCollabsConstants.MyDocCollabs_CheckBoxHoverToolTip;
  documentSearchResult:DocumentSearchResult[] = [];
  panelListType:string = DocumentLibraryConstants.DocCollaborator_PanelListType;
  showLoader: boolean = true;
  isScreenAccessible : boolean = true;
  errorMessage !: string;

  constructor(private myDocCollabsService:MyDocCollabsService){ 
  }


  ngOnInit(): void {
    this.getPanelListData(this.isIncludeAll);
  }
  
    includeInactive(isIncludeAll: boolean) {
    this.showLoader = true;
    this.getPanelListData(isIncludeAll);
  }
  getPanelListData(isIncludeAll : boolean){
      this.myDocCollabsService.getMyDocCollabs(isIncludeAll).subscribe({
          error: (err) => {
              if (err.status === LabelConstants.Forbidden_StatusCode) {
                  this.errorMessage = err.error.detail;
              }
              this.isScreenAccessible = false
          },
          next: (serviceData) => {
              this.documentSearchResult = serviceData,
              this.showLoader = false;
          }
    });
  }
}
